export const DEFAULT_AVATAR_URL = "https://default-avatar.png"
